import { LightbulbAlertOutlineIcon } from './LightbulbAlertOutlineIcon';

/**
 * author: Michael Irigoyen
 * id AC5BBA36-C64C-4E2F-B0E9-2B35A4D9FFE8
 * name lightbulb-alert-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-alert-outline.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const LightbulbErrorOutlineIcon = LightbulbAlertOutlineIcon;
export default LightbulbErrorOutlineIcon